export default "/Frontend/dist/event-background.25eafb415758def8aed2dd07b155a846.svg";